module.exports = __webpack_public_path__ + "img/gerendianpuNew.2e97807f.png";